import { Input } from 'antd';
import PropTypes from 'prop-types';
import { FormEditSummaryItem } from './FormEditSummaryItem';

export const EditSummaryTextAreaField = ({ field, onFinish }) => {
  return (
    <FormEditSummaryItem onFinish={onFinish} field={field}>
      <Input.TextArea />
    </FormEditSummaryItem>
  );
};

EditSummaryTextAreaField.propTypes = {
  field: PropTypes.object,
  onFinish: PropTypes.func,
};
